import {React} from '@api'
import * as css from './IconButton.css'

export const IconButton = (props) => <button {...props} className={css.root} />



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/IconButton/IconButton.tsx